// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rn-0";